export default __webpack_public_path__ + "static/media/1-6.5b35cfe1.png";